import { KeyValuePair } from '../../type';
import { ComboOption, XOptionType } from './type';

export const enumToComboOptionTransformer = (
  enumType: Record<string, string>,
  sort?: (a: [string, string], b: [string, string]) => any
): ComboOption<KeyValuePair>[] => {
  let list = Object.entries(enumType)

  if (sort)
    list = list.sort(sort)

  return list.map<ComboOption<KeyValuePair>>(([key, value]) => ({
    value,
    display: key,
    item: {key: key.toString(), value}
  }))
}

export function mapToSelectOptions<T>(options: ComboOption<T>[]): XOptionType<T>[] {
  return options.map(item => ({
    value: item.value,
    label: item.display,
    item: item.item
  }))
}
